<script setup lang="ts">

import FullScreenModel from '@/components/Interface/Modal/ModelSizes/FullScreenModel.vue'
import BattleReportPlayBack from '@/components/Interface/Modal/Modals/BattleReport/BattleReportPlayBack.vue'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import FormSelect from '@/components/Elements/Forms/FormSelect.vue'
import { ref, computed } from 'vue'
import { useBattleReportStore } from '@/stores/battleReportStore.ts'
import BattleReportAttackerStats from '@/components/Interface/Modal/Modals/BattleReport/BattleReportAttackerStats.vue'
import BattleReportDefenderStats from '@/components/Interface/Modal/Modals/BattleReport/BattleReportDefenderStats.vue'
import { useGameStore } from '@/stores/gameStore.ts'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

/**
 * Stores
 */
const battleReportStore = useBattleReportStore();
const gameStore = useGameStore()

/**
 * Variables
 */
const leftOpen = ref(false)
const rightOpen = ref(false)

const speedOptions = computed(() => [
  { value: '200', label: t('modals.battleReport.speed.slow') },
  { value: '100', label: t('modals.battleReport.speed.normal') },
  { value: '50', label: t('modals.battleReport.speed.fast') },
  { value: '0', label: t('modals.battleReport.speed.max') }
])

/**
 * Functions
 */
const openLeft = () => {
  leftOpen.value = !leftOpen.value;
  rightOpen.value = false
}

const openRight = () => {
  rightOpen.value = !rightOpen.value;
  leftOpen.value = false
}

</script>

<template>
  <FullScreenModel :title="t('modals.battleReport.title')">
    <div class="h-[calc(100%-4rem)] relative">
      <div v-if="battleReportStore.winner === gameStore.player?.id" class="absolute top-24 text-green-500 left-1/2 -translate-x-1/2 z-50" style="font-size: 4rem;">
        {{ t('modals.battleReport.victory') }}
      </div>
      <div v-if="battleReportStore.winner !== gameStore.player?.id && battleReportStore.winner !== 0" class="absolute top-24 text-red-500 left-1/2 -translate-x-1/2 z-50" style="font-size: 4rem;">
        {{ t('modals.battleReport.defeat') }}
      </div>
      <div v-if="leftOpen" class="absolute w-full z-50 bottom-10 block xl:hidden">
        <BattleReportAttackerStats/>
      </div>
      <div v-if="rightOpen" class="absolute w-full z-50 bottom-10 right-0 block xl:hidden">
        <BattleReportDefenderStats/>
      </div>
      <div class="flex">
        <div class="w-96 hidden xl:block px-1">
          <div>
            <BattleReportAttackerStats/>
          </div>
        </div>
        <div class="relative w-full">
          <ActionButton class="absolute bottom-0 left-0 xl:hidden m-1" @click="openLeft">{{ t('command.battleSimulator.attackerStats') }}</ActionButton>
          <FormSelect
            v-model="battleReportStore.playSpeed"
            :options="speedOptions"
            class="absolute bottom-0 left-1/2 -translate-x-1/2 mb-1 w-auto"
          />

          <ActionButton class="absolute bottom-0 right-0 xl:hidden m-1" @click="openRight">{{ t('command.battleSimulator.defenderStats') }}</ActionButton>
          <BattleReportPlayBack/>
        </div>
        <div class="w-96 hidden xl:block px-1">
          <div>
            <BattleReportDefenderStats/>
          </div>
        </div>
      </div>
    </div>
  </FullScreenModel>

</template>

<style scoped lang="scss">

</style>